// node-runnable check for deepLink.js:
//   npx esbuild resources/js/Pages/Sos2/deepLink.selftest.js --bundle --platform=node | node
import { parseLrTarget, canonicalUnitId, resolveLrUnit } from './deepLink';

let fails = 0;
const eq = (label, got, want) => {
  const g = JSON.stringify(got), w = JSON.stringify(want);
  if (g !== w) { fails++; console.log(`✗ ${label}\n    got  ${g}\n    want ${w}`); } else console.log(`✓ ${label}`);
};

eq('findings', parseLrTarget('findings'), { kind: 'findings' });
eq('axes bare', parseLrTarget('axes'), { kind: 'axes', axis: null });
eq('axes axis', parseLrTarget('Axes:Pressure'), { kind: 'axes', axis: 'pressure' });
eq('patterns bare', parseLrTarget('patterns'), { kind: 'patterns', grain: 'overview', focus: null });
eq('patterns grain plural', parseLrTarget('patterns:scenes'), { kind: 'patterns', grain: 'scene', focus: null });
eq('patterns habit', parseLrTarget('patterns:sequence:2'), { kind: 'patterns', grain: 'sequence', focus: { habit: 2 } });
eq('patterns other', parseLrTarget('patterns:scene:other'), { kind: 'patterns', grain: 'scene', focus: { other: true } });
eq('patterns bad grain', parseLrTarget('patterns:chapter'), null);
eq('unit + axis', parseLrTarget('scene-35:pressure'), { kind: 'unit', id: 'scene-35', axis: 'pressure' });
eq('empty', parseLrTarget('  '), null);
eq('null', parseLrTarget(null), null);

eq('canon 35', canonicalUnitId('35'), 'scene-35');
eq('canon sc35', canonicalUnitId('sc35'), 'scene-35');
eq('canon scene-07', canonicalUnitId('scene-07'), 'scene-7');
eq('canon seq', canonicalUnitId('sequence-2b-7'), 'seq-2b-7');
eq('canon act', canonicalUnitId('Act-2B'), 'act-2b');
eq('canon script', canonicalUnitId('script'), 'script');

const nodes = [
  { id: 'Movie', nodeType: 'movie' },
  { id: 'act-2b', nodeType: 'act', detailedContent: { unit_id: 'act-2b' } },
  { id: 'seq-2b-7', nodeType: 'sequence', detailedContent: { unit_id: 'seq-2b-7' } },
  { id: 'scene-35', nodeType: 'scene', detailedContent: { unit_id: 'scene-35', number: 35 } },
  { id: 'stage-u9', nodeType: 'scene', detailedContent: { unit_id: 'stage-u9', number: 9 } },
];
eq('resolve scene', resolveLrUnit(nodes, 'scene-35')?.id, 'scene-35');
eq('resolve by number', resolveLrUnit(nodes, '9')?.id, 'stage-u9');
eq('resolve seq', resolveLrUnit(nodes, 'seq-2b-7')?.id, 'seq-2b-7');
eq('resolve act case', resolveLrUnit(nodes, 'ACT-2B')?.id, 'act-2b');
eq('resolve script', resolveLrUnit(nodes, 'script')?.id, 'Movie');
eq('resolve missing', resolveLrUnit(nodes, 'scene-99'), null);
eq('resolve no nodes', resolveLrUnit([], 'scene-1'), null);

console.log(fails ? `\n${fails} FAILED` : '\nall passed');
process.exitCode = fails ? 1 : 0;
